export default __webpack_public_path__ + "static/media/RIGHT_2_icon.96837981.svg";